import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/navigate_left_32px.png'


const _withScopeId = n => (_pushScopeId("data-v-6068e4be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "body-width",
  id: "my_account"
}
const _hoisted_2 = { class: "page-head-menu" }
const _hoisted_3 = { class: "page-back" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icons_navigate_left_32px",
  class: "icon-32"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 0,
  class: "description"
}
const _hoisted_8 = { class: "pr-10" }
const _hoisted_9 = { class: "pr-10 fc-primary" }
const _hoisted_10 = {
  key: 0,
  class: "box-card tab-edit box-heigth"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_profile = _resolveComponent("my-profile")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_my_company = _resolveComponent("my-company")!
  const _component_plan_and_billing = _resolveComponent("plan-and-billing")!
  const _component_refer_a_friend = _resolveComponent("refer-a-friend")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
          class: "btn-back"
        }, _hoisted_5),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("myAccount.My_Account")), 1),
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user.email), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event)),
            class: "demo-tabs"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('myAccount.My_Profile') || 'My Profile',
                name: "My_Profile",
                class: "p-52"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_my_profile)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('myAccount.My_Company') || 'My Company',
                name: "My_Company",
                class: "p-52"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_my_company)
                ]),
                _: 1
              }, 8, ["label"]),
              (_ctx.paymentEnabled)
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 0,
                    label: _ctx.$t('myAccount.Plan_and_Billing') || 'Plan and Billing',
                    name: "Plan_Billing",
                    class: "p-52"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_plan_and_billing)
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              (_ctx.paymentEnabled)
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 1,
                    label: _ctx.$t('myAccount.Refer_a_friend') || 'Referral a friend',
                    name: "Refer_a_friend",
                    class: "p-52"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_refer_a_friend)
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ]))
}